import { useQuery } from 'react-query';

import BindersAPI from '@app/api/public/BindersApi';

export const useGetProductDetail = (productId: number, propertyId: number) => {
    return useQuery(['getProductDetail', propertyId, productId], () =>
        BindersAPI.getProductDetail(propertyId, productId)
    );
};
